import { File } from './file'
import { Video } from './video'
import { Translator } from './translator'
import { Question } from './question.model'
export class EnglishCourse extends Translator{
    id:string = ""
    nameEn:string = ""
    nameKh:string = ""
    image:File
    videos:[Video]
    descriptionEn:string = ""
    descriptionKh:string = ""
    studentsCount:number = 0
    youtubeId:string = ""
    createdAt:any
    updatedAt:any
    levelId:string
    viewCount:number = 0
    quiz:Question[]
    instruction:string = ""
    audioUrl:string = ""
    audio:any = null
    constructor(){
        super()
    }
    get name():string{
        return this.translate(this.nameEn,this.nameKh)
    }
    get description():string {
        return this.translate(this.descriptionEn,this.descriptionKh)
    }

}